import { MDCRipple } from "@material/ripple";
import { storageConstants } from "@/utils/enum/StorageConstants";
import AceEditor from "vue2-ace-editor";

import AnsiUp from "ansi_up";

import "brace/theme/chrome";
import "brace/theme/clouds";
import "brace/theme/crimson_editor";
import "brace/theme/dawn";
import "brace/theme/dreamweaver";
import "brace/theme/eclipse";
import "brace/theme/github";
import "brace/theme/iplastic";
import "brace/theme/katzenmilch";
import "brace/theme/kuroir";
import "brace/theme/solarized_light";
import "brace/theme/sqlserver";
import "brace/theme/textmate";
import "brace/theme/tomorrow";
import "brace/theme/xcode";
import "brace/theme/ambiance";
import "brace/theme/chaos";
import "brace/theme/clouds_midnight";
import "brace/theme/cobalt";
import "brace/theme/dracula";
import "brace/theme/gob";
import "brace/theme/gruvbox";
import "brace/theme/idle_fingers";
import "brace/theme/kr_theme";
import "brace/theme/merbivore";
import "brace/theme/merbivore_soft";
import "brace/theme/mono_industrial";
import "brace/theme/monokai";
import "brace/theme/pastel_on_dark";
import "brace/theme/solarized_dark";
import "brace/theme/terminal";
import "brace/theme/tomorrow_night";
import "brace/theme/tomorrow_night_blue";
import "brace/theme/tomorrow_night_bright";
import "brace/theme/tomorrow_night_eighties";
import "brace/theme/twilight";
import "brace/theme/vibrant_ink";
import "brace/mode/python";
import snackMessage from "@/plugins/snackMessage";
import { MDCSelect } from "@material/select";
import localStorageUtil from "@/utils/localStorageUtil";

export const csStudyType = {
  data() {
    return {
      memberId: Number,
      componentName: null,
      slideFiles: [],
      lessonData: null,
      lessonName: "",
      nextLessonName: "",
      currentProgressionId: "",
      rate: 0,
      last: 0,
      recent: 0,
      time: 0,
      showLectureList: false,
      currentSlide: 0,

      //타임라인 관련 데이터(timeline data)
      isTimelineQuiz: false,
      isTimelineResource: false,
      timelineContents: [],
      currentTimelineContents: null,

      // nextLessonDialog: null
      currentTab: "tab1",
      name: "",
      teacher: "",
      teacherName: "",
      learnPurposes: "",
      basicData: null,
      thumbnails: null,
      questionChat: null,
      video: null,
      togglePipButton: null,
      addedMenu: null,
      hideVideoTiSub: false,
      slidingVideoArr: [],
      tab2Val: false,

      isQuestionAns: false,
      isLearningObjective: false,
      isResources: false,
      isQnAVisible: false,
      isQuizVisible: false,
      isResourceVisible: false,
      content: "",

      //Computer Sicence
      learningLanguage: "",
      socketUrl: "",
      authorization: "",
      sessionId: "",
      socket: null,
      ansi: undefined,
      socketResult: "",
      inputPrompt: "",
      themePath: "ace/theme/twilight",
      options: {},
      isChat: false,
      sectionInfo: {},
      sectionList: [],
      personalInfo: {},
      theme2List: [
        // {name: 'Monokai', value: 'ace/theme/monokai' },
        { name: "Chrome", value: "ace/theme/chrome" },
        { name: "Clouds", value: "ace/theme/clouds" },
        { name: "Crimson Editor", value: "ace/theme/crimson_editor" },
        { name: "Dawn", value: "ace/theme/dawn" },
        { name: "Dreamweaver", value: "ace/theme/dreamweaver" },
        { name: "Eclipse", value: "ace/theme/eclipse" },
        { name: "GitHub", value: "ace/theme/github" },
        { name: "IPlastic", value: "ace/theme/iplastic" },
        { name: "KatzenMilch", value: "ace/theme/katzenmilch" },
        { name: "Kuroir", value: "ace/theme/kuroir" },
        { name: "Solarized Light", value: "ace/theme/solarized_light" },
        { name: "SQL Server", value: "ace/theme/sqlserver" },
        { name: "TextMate", value: "ace/theme/textmate" },
        { name: "Tomorrow", value: "ace/theme/tomorrow" },
        { name: "XCode", value: "ace/theme/xcode" },
        { name: "Ambiance", value: "ace/theme/ambiance" },
        { name: "Chaos", value: "ace/theme/chaos" },
        { name: "Clouds Midnight", value: "ace/theme/clouds_midnight" },
        { name: "Cobalt", value: "ace/theme/cobalt" },
        { name: "Dracula", value: "ace/theme/dracula" },
        { name: "Greeon on Black", value: "ace/theme/gob" },
        { name: "Gruvbox", value: "ace/theme/gruvbox" },
        { name: "idle Fingers", value: "ace/theme/idle_fingers" },
        { name: "krTheme", value: "ace/theme/kr_theme" },
        { name: "Merbivore", value: "ace/theme/merbivore" },
        { name: "Merbivore Soft", value: "ace/theme/merbivore_soft" },
        { name: "Mono Industrial", value: "ace/theme/mono_industrial" },
        { name: "Monokai", value: "ace/theme/monokai" },
        { name: "Pastel on Dark", value: "ace/theme/pastel_on_dark" },
        { name: "Solarized Dark", value: "ace/theme/solarized_dark" },
        { name: "Terminal", value: "ace/theme/terminal" },
        { name: "Tomorrow Night", value: "ace/theme/tomorrow_night" },
        { name: "Tomorrow Night Blue", value: "ace/theme/tomorrow_night_blue" },
        {
          name: "Tomorrow Night Bright",
          value: "ace/theme/tomorrow_night_bright"
        },
        {
          name: "Tomorrow Night 80s",
          value: "ace/theme/tomorrow_night_eighties"
        },
        { name: "Twilight", value: "ace/theme/twilight" },
        { name: "Vibrant Ink", value: "ace/theme/vibrant_ink" }
      ],
    };
  },

  watch: {
    $route() {
      this.darkModeInit();
    },

    lightModeActive() {
      this.setEditorTheme();
    }
  },

  created() {
    this.darkModeInit();
  },

  beforeMount() {
    this.ansi = new AnsiUp();
  },

  mounted() {
    this.memberId = localStorage.getItem(storageConstants.memberId);
    this.setMaterialUi();

    const column = document.querySelector("#columnValue");
    (function resizableY() {
      const resizer = document.querySelector(".resizer-y");

      resizer.addEventListener("mousedown", onmousedown);
      resizer.addEventListener("touchstart", ontouchstart);

      // for mobile
      function ontouchstart(e) {
        e.preventDefault();
        resizer.addEventListener("touchmove", ontouchmove);
        resizer.addEventListener("touchend", ontouchend);
      }

      function ontouchmove(e) {
        e.preventDefault();

        const clientX = e.clientX;
        const deltaX = clientX - (resizer._clientX || clientX);
        resizer._clientX = clientX;
        const l = resizer.previousElementSibling;
        const r = resizer.nextElementSibling;

        // LEFT
        if (deltaX < 0) {
          const w = Math.round(parseInt(getComputedStyle(l).width) + deltaX);
          l.style.flex = `0 ${w < 10 ? 0 : w}px`;
          r.style.flex = "1 0";
        }
        // RIGHT
        if (deltaX > 0) {
          const w = Math.round(parseInt(getComputedStyle(r).width) - deltaX);
          r.style.flex = `0 ${w < 10 ? 0 : w}px`;
          l.style.flex = "1 0";
        }
      }

      function ontouchend(e) {
        e.preventDefault();
        resizer.removeEventListener("touchmove", ontouchmove);
        resizer.removeEventListener("touchend", ontouchend);
        if (column._value) {
          delete e._clientX;
        } else {
          delete e._clientY;
        }
      }

      // for desktop
      function onmousedown(e) {
        e.preventDefault();
        document.addEventListener("mousemove", onmousemove);
        document.addEventListener("mouseup", onmouseup);
      }

      function onmousemove(e) {
        e.preventDefault();

        if (column._value) {
          const clientX = e.clientX;
          const deltaX = clientX - (resizer._clientX || clientX);
          resizer._clientX = clientX;
          const l = resizer.previousElementSibling;
          const r = resizer.nextElementSibling;

          // LEFT
          if (deltaX < 0) {
            const w = Math.round(parseInt(getComputedStyle(l).width) + deltaX);
            l.style.flex = `0 ${w < 10 ? 0 : w}px`;
            r.style.flex = "1 0";
          }
          // RIGHT
          if (deltaX > 0) {
            const w = Math.round(parseInt(getComputedStyle(r).width) - deltaX);
            r.style.flex = `0 ${w < 10 ? 0 : w}px`;
            l.style.flex = "1 0";
          }
        } else {
          const clientY = e.clientY;
          const deltaY = clientY - (resizer._clientY || clientY);
          resizer._clientY = clientY;
          const t = resizer.previousElementSibling;
          const b = resizer.nextElementSibling;

          // UP
          if (deltaY < 0) {
            const h = Math.round(parseInt(getComputedStyle(t).height) + deltaY);
            t.style.flex = `0 ${h < 10 ? 0 : h}px`;
            b.style.flex = "1 0";
          }
          // DOWN
          if (deltaY > 0) {
            const h = Math.round(parseInt(getComputedStyle(b).height) - deltaY);
            b.style.flex = `0 ${h < 10 ? 0 : h}px`;
            t.style.flex = "1 0";
          }
        }
      }

      function onmouseup(e) {
        e.preventDefault();
        document.removeEventListener("mousemove", onmousemove);
        document.removeEventListener("mouseup", onmouseup);
        if (column._value) {
          delete e._clientX;
        } else {
          delete e._clientY;
        }
      }
    })();

    (function resizableX() {
      const resizer = document.querySelector(".resizer-x");
      resizer.addEventListener("mousedown", onmousedown);
      resizer.addEventListener("touchstart", ontouchstart);

      // for mobile
      function ontouchstart(e) {
        e.preventDefault();
        resizer.addEventListener("touchmove", ontouchmove);
        resizer.addEventListener("touchend", ontouchend);
      }

      function ontouchmove(e) {
        e.preventDefault();
        const clientX = e.touches[0].clientX;
        const deltaX = clientX - (resizer._clientX || clientX);
        resizer._clientX = clientX;
        const l = resizer.previousElementSibling;
        const r = resizer.nextElementSibling;
        // LEFT
        if (deltaX < 0) {
          const w = Math.round(parseInt(getComputedStyle(l).width) + deltaX);
          l.style.flex = `0 ${w < 10 ? 0 : w}px`;
          r.style.flex = "1 0";
        }
        // RIGHT
        if (deltaX > 0) {
          const w = Math.round(parseInt(getComputedStyle(r).width) - deltaX);
          r.style.flex = `0 ${w < 10 ? 0 : w}px`;
          l.style.flex = "1 0";
        }
      }
      function ontouchend(e) {
        e.preventDefault();
        resizer.removeEventListener("touchmove", ontouchmove);
        resizer.removeEventListener("touchend", ontouchend);
        delete e._clientX;
      }

      // for desktop
      function onmousedown(e) {
        e.preventDefault();
        document.addEventListener("mousemove", onmousemove);
        document.addEventListener("mouseup", onmouseup);
      }

      function onmousemove(e) {
        e.preventDefault();
        const clientX = e.clientX;
        const deltaX = clientX - (resizer._clientX || clientX);
        resizer._clientX = clientX;
        const l = resizer.previousElementSibling;
        const r = resizer.nextElementSibling;

        // LEFT
        if (deltaX < 0) {
          const w = Math.round(parseInt(getComputedStyle(l).width) + deltaX);
          l.style.flex = `0 ${w < 10 ? 0 : w}px`;
          r.style.flex = "1 0";
        }
        // RIGHT
        if (deltaX > 0) {
          const w = Math.round(parseInt(getComputedStyle(r).width) - deltaX);
          r.style.flex = `0 ${w < 10 ? 0 : w}px`;
          l.style.flex = "1 0";
        }
      }
      function onmouseup(e) {
        e.preventDefault();
        document.removeEventListener("mousemove", onmousemove);
        document.removeEventListener("mouseup", onmouseup);
        delete e._clientX;
      }
    })();
  },

  computed: {
    isChatComp() {
      return (this.isChat = !this.isChat);
    }
  },

  methods: {
    html(ansiData) {
      this.socketResult += this.ansi
        .ansi_to_html(ansiData)
        .replace(/\n/gm, "<br>");
    },

    initEditor(editor) {
      editor.setOptions({
        fontSize: "16px",
        // maxLines: 50,
        // minLines: 50,
        theme: this.setEditorTheme(),
        printMargin: false, // boolean | number: showPrintMargin | printMarginColumn
        wrap: false, // boolean | string | number: true/'free' means wrap instead of horizontal scroll, false/'off' means horizontal scroll instead of wrap, and number means number of column before wrap. -1 means wrap at print margin
        scrollPastEnd: 0.1, // number -> !maxLines: if positive, user can scroll pass the last line and go n * editorHeight more distance
        scrollSpeed: 2, // number: the scroll speed index
        autoScrollEditorIntoView: true,
        mode: "ace/mode/python",
        maxLines: Infinity
      });
    },

    setEditorTheme(event) {
      if (event) {
        this.themePath = event.target.value;
        localStorage.setItem("themePath", this.themePath);
      } else {
        let setLightMode = "";
        localStorage.getItem("themeMode") === "light"
          ? (setLightMode = "ace/theme/chrome")
          : (setLightMode = "ace/theme/twilight");
        localStorage.getItem("themePath")
          ? (this.themePath = localStorage.getItem("themePath"))
          : (this.themePath = setLightMode);
      }

      this.$nextTick(() => {
        this.$refs.myEditor.editor.setOptions({
          theme: this.themePath
        });
      });
    },

    //WebSocket Close Method
    onClose(event) {
      console.log(event);
      console.log("Successfully closed to the echo websocket server...");
    },

    //WebSocket Open Method
    onOpen(event) {
      console.log(event);
      console.log("Successfully connected to the echo websocket server...");
    },

    //WebSocket Message 수신 Method
    onMessage(event) {
      const socketContent = JSON.parse(event.data);
      switch (socketContent.msg_type) {
        case "stream":
          this.socketResult += socketContent.content.text.replace(
              /(\r\n|\n|\r)/gm,
              "<br/>"
          );
          break;
        case "display_data":
          this.socketResult += `<img src='data:image/png;base64,${socketContent.content.data["image/png"]}' style='width:391px' />`;
          break;
        case "input_request":
          this.inputPrompt = socketContent.content.prompt.replace(/"/g, '');
          this.socketResult += `
            ${this.inputPrompt}
            <input class="input-box" v-model="inputData">`
          this.$nextTick(() => {
            this.inputSocketResultRender();
          });
          break;
        case "execute_result":
          // debugger;
          this.socketResult += socketContent.content.data["text/plain"].replace(
              /(\r\n|\n|\r)/gm,
              "<br/>"
          );
          break;
        case "error":
          let traceHtml = "";
          socketContent.content.traceback.forEach(function(traceback, index) {
            traceHtml += traceback;
          });
          this.html(traceHtml);
          break;
      }
    },

    onError(event) {
      console.log("Oops Websocket Server Error");
    },

    inputSocketResultRender() {
      const inputElement = this.$refs.socketResultContainer.querySelector('.input-box');
      if (inputElement) {
        inputElement.focus();
        inputElement.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            const inputValue = event.target.value;
            this.sendInputMessage(inputValue);
            this.removeInputElement(inputValue);
          }
        });
      }
    },

    // Remove the input element from socketResult
    removeInputElement(inputValue) {
      this.socketResult = this.socketResult.replace('<input class="input-box" v-model="inputData">', inputValue + "<br/>");
    },

    sendInputMessage(value) {
      let sendData = {
        header: {
          msg_id: Math.random().toString(32),
          username: "username",
          session: this.sessionId,
          msg_type: "input_reply",
          version: "5.2"
        },
        metadata: {},
        content: {
          value: value,
        },
        buffers: [],
        parent_header: {},
        channel: "stdin"
      };
      // this.socketResult = "";
      this.socket.send(JSON.stringify(sendData));
    },

    async sendMessage() {
      if (this.isServerStop) {
        return;
      }

      let sendData = {
        header: {
          msg_id: Math.random().toString(32),
          username: "username",
          session: this.sessionId,
          msg_type: "execute_request",
          version: "5.2"
        },
        metadata: {},
        content: {
          code: this.content,
          silent: false,
          store_history: true,
          user_expressions: {},
          allow_stdin: true,
          stop_on_error: true
        },
        buffers: [],
        parent_header: {},
        channel: "shell"
      };
      this.socketResult = "";
      // 문서 저장 API 보류
      // this.updateContents(this.$route.params.lessonId, this.$route.params.progressionId);
      this.socket.send(JSON.stringify(sendData));
    },

    resetMessage() {
      this.content = "";
      this.socketResult = "";
    },

    downloadExecFile() {
      const filename = this.csFileName;
      var l = document.createElement("a");
      l.href = "data:text/plain;charset=UTF-8," + this.content;
      l.setAttribute("download", filename);
      l.click();
    },

    darkModeInit() {
      const article = document.querySelector("html");
      const modeContent = article.getAttribute("data-theme");

      if (localStorage.getItem("themeMode")) {
        article.setAttribute("data-theme", localStorage.getItem("themeMode"));
        this.lightModeActive = localStorage.getItem("themeMode") !== "dark";
      } else {
        if (modeContent === "dark") {
          this.lightModeActive = false;
        } else {
          this.lightModeActive = true;
        }
      }
    },

    getLearnPurposes(obj) {
      const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
      const learnInfo = obj.find(info => info.lang.value === languageInfo.code);
      return learnInfo ? learnInfo.summary : "";
    },

    moveLearnViewClose() {
      let goBackBookMarkLessson = localStorage.getItem("videoBookMarkLesson");
      let goBackLikeLessson = localStorage.getItem("videoLikeLesson");
      if (goBackBookMarkLessson === "setVideoBookMarkLesson") {
        localStorage.removeItem("videoBookMarkLesson");
        this.$router.push({
          name: "BookMarkedLesson"
        });
      } else if (goBackLikeLessson === "setVideoLikeLesson") {
        localStorage.removeItem("videoLikeLesson");
        this.$router.push({
          name: "LikedLesson"
        });
      } else {
        this.$router.go(-1);
      }
    },

    darkModeToLight() {
      const article = document.querySelector("html");
      const modeContent = article.getAttribute("data-theme");
      localStorage.setItem(
        "themeMode",
        modeContent === "dark" ? "light" : "dark"
      );
      article.setAttribute(
        "data-theme",
        modeContent === "dark" ? "light" : "dark"
      );
      this.lightModeActive = !this.lightModeActive;
    },

    setisQuestionAns() {
      this.isChat = !this.isChat;
      this.isQuestionAns = !this.isQuestionAns;
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function(el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
      const select = new MDCSelect(document.querySelector("#selectTheme"));
    }
  }
};
